module.exports = __webpack_public_path__ + "assets/media/hired-photo.86b90ceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/hired-photo.jpg
// module id = 3244
// module chunks = 0